import React, { useCallback } from 'react';
import { getMessage } from 'util/locale';
import BaseModal from 'common/modals/BaseModal';
import { useRedirectUrl } from 'util/hooks/useRedirectUrl';
import { useCropPlanStash } from 'util/hooks/useCropPlanStash';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getActiveScriptId, getConfirmModal } from 'current/selectors';
import { isCropPlanIntegrationEnabled } from 'user/selectors';
import { closeConfirmModal } from 'current/uiwidgets';
import { manageScripts, saveScript } from 'scripts';

const baseString = 'vra-confirm-modal';
const ConfirmModal = () => {
  const [cropPlan] = useCropPlanStash();
  const isConfirmModalOpen = useAppSelector(getConfirmModal);
  const scriptId = useAppSelector(getActiveScriptId);
  const isCropPlanIntegration = useAppSelector(isCropPlanIntegrationEnabled);
  const dispatch = useAppDispatch();
  const redirectUrl = useRedirectUrl();

  const cancelConfirmModal = useCallback(() => {
    dispatch(closeConfirmModal());
  }, [dispatch]);


  const saveConfirmModal = useCallback(() => {
    dispatch(saveScript(
      {
        scriptId,
        cropPlan: isCropPlanIntegration ? cropPlan : null,
        redirectUrl
      }
    ));
    dispatch(closeConfirmModal());

    if (redirectUrl){
      return;
    }

    dispatch(manageScripts());
  }, [dispatch, scriptId, cropPlan, isCropPlanIntegration, redirectUrl]);

  return isConfirmModalOpen ? (
    <BaseModal
      isOpen={true}
      onCancel={cancelConfirmModal}
      onSave={saveConfirmModal}
      saveText={getMessage('button-text__save-changes')}
      shouldCloseOnOverlayClick={true}>
      <div className={`${baseString}`}>
        { getMessage('help-text__confirm-save-prescription') }
      </div>
    </BaseModal>
  ) : null;
};

export default ConfirmModal;
